<div class="message-box" [ngClass]="{ active: state }">
  <p [ngClass]="messageService.type">{{ messageService.message | async }}</p>
</div>
